import apiService from '@/services/apiService';

const actions = {
  postTags({ commit }, payload) {
    console.log(commit);
    console.log('commit');
    console.log(payload);
    console.log('payload');
    apiService.setHeader();
    return new Promise((resolve, reject) => {
      apiService.post('article/find-suggestion-tags-with-paging', payload)
        .then((response) => {
          // commit('postTags', response.data.data.results);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getArticles({ commit }) {
    apiService.setHeader();
    return new Promise((resolve, reject) => {
      apiService.get('article')
        .then((response) => {
          commit('getArticles', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getArticles2({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('article/find-with-paging', payload)
        .then((response) => {
          commit('getArticles2', response.data.data);
          console.log(response);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getDimension({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`additional-info/dimension/${payload}`)
        .then((response) => {
          commit('getDimension', response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCountHighlight({ commit }) {
    apiService.setHeader();
    apiService.post('article/count-highlight')
      .then((response) => {
        commit('getCountHighlight', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getArticle({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`article/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAdminhub({ commit }) {
    apiService.setHeader();
    apiService.get('additional-info/admin-hub')
      .then((response) => {
        commit('getAdminhub', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getPackageSize({ commit }) {
    apiService.get('additional-info/package-size')
      .then((response) => {
        commit('getPackageSize', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  getAddon({ commit }) {
    apiService.setHeader();
    apiService.get('additional-info/add-on')
      .then((response) => {
        commit('getAddon', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getExtraPackaging({ commit }) {
    apiService.setHeader();
    apiService.get('additional-info/extra-packaging')
      .then((response) => {
        commit('getExtraPackaging', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getDimension({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`additional-info/dimension/${payload}`)
        .then((response) => {
          commit('getDimension', response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  postArticles({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('article', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateStatusArticles({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('article/update-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  orderArticle({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`article/${payload.id}/change-order-category`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  orderArticleHighlight({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`article/${payload.id}/change-order-highlight`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putArticles({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`article/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delArticle({ commit }, payload) {
    apiService.delete(`article/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};

export default actions;
